import React from "react";
import { breeders } from "../data/content";
import { Reveal } from "./Reveal";
export function Breeders() {
  const [lead, ...rest] = breeders;
  return <section id="bengals" className="bg-night py-24 lg:py-36" data-id="element-47" data-mp="1qhgpjbqrjj6s">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-48" data-mp="24du5ggfnfcj5">
        <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-49" data-mp="1zgbs8dulmb5c">
          <h2 className="font-display text-4xl text-cream sm:text-5xl lg:text-6xl" data-id="element-50" data-mp="1bqhhc1tuawnq">
            Nos <span className="italic text-sage" data-id="element-51" data-mp="1bo51bu7n6wdb">reproducteurs</span>
          </h2>
          <p className="max-w-sm text-sm leading-relaxed text-stone" data-id="element-52" data-mp="16t7tgqm3mt20">
            Des lignées choisies avec exigence, testées et suivies par notre vétérinaire. Ce sont eux qui transmettent
            leur caractère à nos chatons.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 lg:grid-cols-12" data-id="element-53" data-mp="sz89ry3mqhys">
          <Reveal className="lg:col-span-7" data-id="element-54" data-mp="sxnf88hbez0x">
            <BreederCard breeder={lead} large data-id="element-55" data-mp="nzvnbego7cwq" />
          </Reveal>
          <div className="grid gap-6 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1" data-id="element-56" data-mp="fllkn0xd7rg">
            {rest.map((b, i) => <Reveal key={b.name} delay={(i + 1) * 0.05} data-id="element-57" data-mp="5dn3h4mm711c" data-mpi={i}>
                <BreederCard breeder={b} data-id="element-58" data-mp="5c3pxlscf439" />
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}
type Breeder = (typeof breeders)[number];
function BreederCard({
  breeder,
  large = false
}: {
  breeder: Breeder;
  large?: boolean;
}) {
  return <article className="group relative h-full overflow-hidden rounded-sm bg-coal" data-id="element-59" data-mp="3dnq5wft4ap6c">
      <img src={breeder.image} alt={`${breeder.name}, ${breeder.role.toLowerCase()} Bengal ${breeder.coat}`} className={`w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02] ${large ? "aspect-[4/5] lg:h-full lg:aspect-auto lg:min-h-[640px]" : "aspect-[16/10] lg:aspect-auto lg:h-[308px]"}`} data-id="element-60" data-mp="3ili4tts6jbk1" />
      <div className="absolute inset-x-0 bottom-0 bg-ink/75 p-6 backdrop-blur-sm lg:p-8" data-id="element-61" data-mp="16ue7r9p4j0r2">
        <div className="flex items-end justify-between gap-4" data-id="element-62" data-mp="32xso09ljli57">
          <div data-id="element-63" data-mp="2ywz19jju69dw">
            <p className="text-xs text-sage" data-id="element-64" data-mp="2yx8pp2p8g8hh">{breeder.role}</p>
            <h3 className={`mt-1 font-display text-cream ${large ? "text-5xl" : "text-3xl"}`} data-id="element-65" data-mp="2yz1ppz5cbugi">{breeder.name}</h3>
          </div>
          <div className="text-right text-xs leading-relaxed text-stone" data-id="element-66" data-mp="37xwur7wneyi8">
            <p data-id="element-67" data-mp="37vkdyy2mmu6r">{breeder.coat}</p>
            <p data-id="element-68" data-mp="2k7jcg93v8e0u">{breeder.tests}</p>
          </div>
        </div>
      </div>
    </article>;
}